module.exports = __webpack_public_path__ + "img/georgia.67118910.png";